function initNuvanaProducts(root) {
  root.querySelectorAll('[data-nuvana-product]:not([data-ready])').forEach(section => {
    section.dataset.ready = 'true';
    const bundles = Array.from(section.querySelectorAll('[data-lv-bundle]'));
    const updateBundle = () => {
      const selected = bundles.find(input => input.checked);
      if (!selected) return;
      section.querySelectorAll('[data-lv-total]').forEach(total => { total.textContent = selected.dataset.total; });
    };
    bundles.forEach(input => input.addEventListener('change', updateBundle));
    updateBundle();
    const rail = section.querySelector('.lv-slides');
    const buttons = Array.from(section.querySelectorAll('[data-lv-slide]'));
    if (!rail) return;
    buttons.forEach(button => button.addEventListener('click', () => {
      const slide = document.getElementById(button.dataset.lvSlide);
      if (!slide) return;
      rail.scrollTo({left: slide.offsetLeft - rail.firstElementChild.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    rail.addEventListener('scroll', () => {
      const index = Math.round(rail.scrollLeft / rail.clientWidth);
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }, {passive:true});
  });
}
function initNuvanaCountdowns(root) {
  root.querySelectorAll('[data-nuvana-promo]:not([data-timer-ready])').forEach(banner => {
    banner.dataset.timerReady = 'true';
    const timer = banner.querySelector('[data-countdown]');
    if (!timer) return;
    const raw = banner.dataset.countdownEnd || '';
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
    const end = Date.parse(raw);
    if (!Number.isFinite(end)) return;
    let interval;
    const tick = () => {
      if (!banner.isConnected) { clearInterval(interval); return; }
      const remaining = Math.max(0,Math.ceil((end-Date.now())/1000));
      if (!remaining) {
        timer.hidden = true;
        if (banner.dataset.hideExpired === 'true') banner.hidden = true;
        clearInterval(interval);
        return;
      }
      timer.hidden = false;
      timer.querySelector('[data-time-hours]').textContent = String(Math.floor(remaining/3600)).padStart(2,'0');
      timer.querySelector('[data-time-minutes]').textContent = String(Math.floor(remaining/60)%60).padStart(2,'0');
      timer.querySelector('[data-time-seconds]').textContent = String(remaining%60).padStart(2,'0');
    };
    tick();
    if(end>Date.now()) interval=setInterval(tick,1000);
  });
}
function initNuvana(root){initNuvanaProducts(root);initNuvanaCountdowns(root);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initNuvana(document));
else initNuvana(document);
document.addEventListener('shopify:section:load',event=>initNuvana(event.target));
if(!document.querySelector('[data-nuvana-product][data-ready]')){
  const observer=new MutationObserver(()=>{
    if(document.querySelector('[data-nuvana-product]')){initNuvana(document);observer.disconnect();}
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
}
function initNuvanaStoryVideos(section, slides) {
  const videos = Array.from(section.querySelectorAll('.nv-video-player video'));
  if (!videos.length) return () => {};
  const states = new Map(videos.map(video => [video, {visible: false, pausedByUser: false, ignoredPauses: 0, pending: false, blocked: false}]));
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let active = 0;
  let disposed = false;
  const stop = video => {
    if (video.paused) return;
    states.get(video).ignoredPauses++;
    video.pause();
  };
  const eligible = video => !disposed && !document.hidden && section.isConnected && states.get(video).visible && slides[active]?.contains(video);
  const syncSound = video => {
    const button = video.parentElement.querySelector('[data-nv-sound]');
    const muted = video.muted || video.volume === 0;
    button.dataset.muted = String(muted);
    button.setAttribute('aria-pressed', String(!muted));
    button.querySelector('span').textContent = muted ? button.dataset.unmuteLabel : button.dataset.muteLabel;
  };
  const start = async video => {
    const state = states.get(video);
    if (state.pending || state.blocked || !video.paused) return;
    state.pending = true;
    try {
      await video.play();
    } catch (error) {
      if (error.name === 'NotAllowedError' && !video.muted && eligible(video)) {
        video.muted = true;
        syncSound(video);
        try { await video.play(); } catch (fallbackError) { state.blocked = fallbackError.name !== 'AbortError'; }
      } else {
        state.blocked = error.name !== 'AbortError';
      }
    } finally {
      state.pending = false;
      if (!eligible(video)) stop(video);
    }
  };
  const sync = () => {
    videos.forEach(video => {
      const state = states.get(video);
      if (!eligible(video)) { stop(video); return; }
      if (section.dataset.videoAutoplay === 'true' && !reducedMotion.matches && !state.pausedByUser && !video.ended) start(video);
    });
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { states.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio >= .45; });
    sync();
  }, {threshold: [0, .45, 1]});
  videos.forEach(video => {
    const state = states.get(video);
    const button = video.parentElement.querySelector('[data-nv-sound]');
    button.hidden = false;
    syncSound(video);
    button.addEventListener('click', () => {
      const enableSound = video.muted || video.volume === 0;
      video.muted = !enableSound;
      if (enableSound && video.volume === 0) video.volume = 1;
      syncSound(video);
      if (enableSound && video.paused) {
        state.pausedByUser = false;
        state.blocked = false;
        video.play().catch(() => {});
      }
    });
    video.addEventListener('volumechange', () => syncSound(video));
    video.addEventListener('play', () => {
      state.pausedByUser = false;
      state.blocked = false;
      active = slides.indexOf(video.closest('.nv-slide'));
      videos.forEach(other => { if (other !== video) stop(other); });
    });
    video.addEventListener('pause', () => {
      if (state.ignoredPauses) state.ignoredPauses--;
      else if (!video.ended) state.pausedByUser = true;
    });
    observer.observe(video);
  });
  document.addEventListener('visibilitychange', sync);
  reducedMotion.addEventListener('change', sync);
  section.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
    disposed = true;
    observer.disconnect();
    document.removeEventListener('visibilitychange', sync);
    reducedMotion.removeEventListener('change', sync);
    videos.forEach(stop);
  }, {once: true});
  return index => { active = index; sync(); };
}
function initNuvanaStoryCarousels(root) {
  root.querySelectorAll('[data-nv-carousel]:not([data-carousel-ready])').forEach(section => {
    section.dataset.carouselReady = 'true';
    const rail = section.querySelector('.nv-rail');
    const slides = Array.from(rail.querySelectorAll('.nv-slide'));
    const dots = Array.from(section.querySelectorAll('[data-nv-dot]'));
    const nav = section.querySelector('[data-nv-nav]');
    const updateVideos = initNuvanaStoryVideos(section, slides);
    let active = 0;
    const update = () => {
      if (!section.isConnected) return;
      const center = rail.getBoundingClientRect().left + rail.clientWidth / 2;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const next = Math.abs(rect.left + rect.width / 2 - center);
        if (next < distance) { distance = next; active = index; }
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === active)));
      nav.hidden = slides.length < 2 || rail.scrollWidth <= rail.clientWidth + 2;
      section.querySelector('[data-nv-prev]').disabled = rail.scrollLeft < 2;
      section.querySelector('[data-nv-next]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      updateVideos(active);
    };
    const go = index => {
      const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (!slide) return;
      const target = slide.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - (rail.clientWidth - slide.clientWidth) / 2;
      rail.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    section.querySelector('[data-nv-prev]').addEventListener('click', () => go(active - 1));
    section.querySelector('[data-nv-next]').addEventListener('click', () => go(active + 1));
    rail.addEventListener('scroll', update, {passive: true});
    rail.addEventListener('keydown', event => {
      if (event.target !== rail) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const resize = new ResizeObserver(() => { if (!section.isConnected) { resize.disconnect(); return; } update(); });
    resize.observe(rail);
    section.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('.nv-slide');
      if (slide) go(slides.indexOf(slide));
    });
    update();
  });
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initNuvanaStoryCarousels(document));
else initNuvanaStoryCarousels(document);
document.addEventListener('shopify:section:load', event => initNuvanaStoryCarousels(event.target));
